import axios from "axios";
import { APIURL } from "../config";
import useAuth from "../utils/useAuth";

const AddTransactionCommentAPI = async (data) => {
  const user = useAuth();
  const url = APIURL + "/schema/addtransactioncomments";
  return await axios.post(url, { access_token: user.token, ...data });
};

export default AddTransactionCommentAPI;
